export default {
    methods: {
        prefixMoney(criteriojulgamento, validarPor){
            if(criteriojulgamento === 'MAIOR_DESCONTO' && (!validarPor || validarPor === 'PERCENTUAL'))
                return ''
            return 'R$'
        },
        suffixMoney(criteriojulgamento, validarPor){
            if(criteriojulgamento === 'MAIOR_DESCONTO' && (!validarPor || validarPor === 'PERCENTUAL'))
                return  '%'
            return ''
        },
    }
}